module.exports = __webpack_public_path__ + "store/img/paw_card.c79a03a8.png";